import { Cart } from "@dana/Overrides/Services/CartService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import {
    replaceInChain,makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SetCart, ValidateBillingAddress, ValidateShippingAddress } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";
import { getCookie } from "@insite/mobius/utilities/cookies";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import validateAddress, { AddressErrors } from "@dana/Overrides/Store/CommonHandlers/ValidateAddress";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    SetCart,
     props => {
        const state = props.getState() as ApplicationStateDana;
        const cartMode = getCookie('cartMode');
        const { cartId } = state.pages.onePageCheckout;
        let cart: Cart | undefined;
        if (cartMode === 'StockOrderCart') {
            cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value
        } else if (cartMode === 'EmergencyOrderCart') {
            cart = state.emergencyCartState.cart as Cart;
        } else {
            cart = state.annualReturnsCartState.cart as Cart;
        }
        if (!cart) {
            throw new Error("There was no current cart and we are trying to use it to set initial values");
        }
        props.cart = cart;
    }
);

replaceInChain(
    chain,
    ValidateBillingAddress,
    async ({ dispatch, getState, billTo }) => {
            const state = getState();
            const billingAddressFormState = state.pages.onePageCheckout.billingAddressFormState;
            if (!billingAddressFormState) {
                return;
            }
        
            let addressFieldsDataView = getAddressFieldsDataView(state);
            if (!addressFieldsDataView.value) {
                addressFieldsDataView = getAddressFieldsDataView(state);
            }
        
            const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
                validateAddress,
            );
            const billingAddressErrors = await awaitableValidate({
                address: billTo,
                validationRules: billTo.validation!,
                addressFieldDisplayCollection: addressFieldsDataView.value!.billToAddressFields,
            })(dispatch, getState);
            const isBillingAddressValid = Object.keys(billingAddressErrors).length === 0;
        
            dispatch({
                type: "Pages/OnePageCheckout/SetIsBillingAddressUpdateRequired",
                isBillingAddressUpdateRequired: !isBillingAddressValid,
            });
        } 
);

replaceInChain(
    chain,
    ValidateShippingAddress,
 async ({ dispatch, getState, shipTo }) => {
    const state = getState();
    const session = state.context.session;
    if (!shipTo || session.fulfillmentMethod === FulfillmentMethod.PickUp) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const shippingAddressErrors = await awaitableValidate({
        address: shipTo,
        validationRules: shipTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.shipToAddressFields,
    })(dispatch, getState);
    const isShippingAddressValid = Object.keys(shippingAddressErrors).length === 0;

    dispatch({
        type: "Pages/OnePageCheckout/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !isShippingAddressValid,
    });
}
);